import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["filename"]

  updatePreview(event) {
    const input = event.target
    if (input.files && input.files.length > 0) {
      this.filenameTarget.textContent = input.files[0].name
    }
  }
}
